















import { Component, Vue } from 'vue-property-decorator'

@Component
export default class AboutPage extends Vue {
  created () {
    // console.log('about created')
  }

  mounted () {
    // console.log('about mounted')
  }
}
